import { styled, css } from '../../style';

const StyledDiv = styled('div')(
  ({ theme }) => css`
    .account-modal {
      background-color: ${theme.colors.quickModal};
      border: ${theme.colors.cardBorder};
      border-radius: 12px;

      * {
        color: ${theme.colors.primaryText};
      }
    }

    .portfolio-current-value > .value,
    .content {
      color: #000 !important;
    }

    .account-modal > .actions > :not(:first-child) {
      margin: 0;
    }

    .maximus-button {
      background: linear-gradient(
        90deg,
        #ffdc22 0%,
        #ffb90b 96.77%,
        #ffb600 96.77%
      ) !important;
      color: #000 !important;
      cursor: pointer;
      margin: 10px;

      &:hover {
        opacity: 0.8;
      }
    }

    .clear-all {
      color: ${theme.colors.secondaryText} !important;
    }

    .account-modal > .actions {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  `
);

export default StyledDiv;
